import AppProviders from './AppProviders';

export default AppProviders;
